<template>
  <div v-if="showModal" class="modal-container">
    <div
      class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"
    ></div>

    <div
      class="modal-content relative bg-white max-w-lg w-full max-h-[90vh] m-auto flex-col flex rounded-lg shadow-lg"
    >
      <div class="w-full border-b-[1px] mb-4 px-6 py-4">
        <h2 v-if="!isTaskEdit" class="text-[18px] text-grayDark font-bold">New Task</h2>
        <h2 v-else class="text-[18px] text-grayDark font-bold">Edit Task</h2>
      </div>

      <!-- <h1 class="text-xl font-semibold mb-4">{{ project.project_name }}</h1> -->

      <form @submit.prevent="submitTaskModal" class="overflow-y-auto px-6">
        <div class="space-y-4 mb-4">
          <div class="">
            <label class="block text-[13px] font-medium text-gray-700"
              >Task Title</label
            >
            <input
              v-model="newTask.title"
              type="text"
              placeholder="Enter task title"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              :required="!isTaskEdit"
            />
          </div>
          <div class="">
            <label class="block text-[13px] font-medium text-gray-700"
              >Description</label
            >
            <textarea
              v-model="newTask.description"
              placeholder="Enter task description"
              class="mt-1 block w-full h-[152px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              :required="!isTaskEdit"
            ></textarea>
          </div>

          <div class="flex justify-between">
            <div class="">
              <label class="block text-[13px] font-medium text-gray-700"
                >Priority</label
              >
              <select
                v-model="newTask.priority"
                class="mt-1 block w-[220px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                :required="!isTaskEdit"
              >
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>
            <div class="">
              <label class="block text-[13px] font-medium text-gray-700"
                >Due Date</label
              >
              <input
                v-model="newTask.due_date"
                type="date"
                class="mt-1 block w-[220px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                :required="!isTaskEdit"
              />
            </div>
          </div>

          <div class="flex items-center mb-4">
            <label class="flex items-center cursor-pointer">
              <span class="mr-2 text-[13px] font-medium text-gray-700"
                >Assigned To</span
              >
              <div class="relative">
                <input
                  type="checkbox"
                  v-model="isTeamsSelected"
                  class="sr-only"
                />
                <div
                  class="w-10 h-5 bg-gray-200 rounded-full shadow-inner"
                ></div>
                <div
                  class="absolute top-0 left-0 w-5 h-5 bg-blue-500 rounded-full shadow transform transition-transform"
                  :class="{ 'translate-x-5': isTeamsSelected }"
                ></div>
              </div>
              <span class="ml-2 text-[13px] font-medium text-gray-700"
                >Teams</span
              >
            </label>
          </div>

          <div v-if="!isTeamsSelected">
            <label class="block text-[13px] font-medium text-gray-700"
              >Assigned To</label
            >
            <select
              v-if="(!loading && (isAdmin || isManager))"
              v-model="newTask.assigned_to"
              placeholder="Select team member"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              :required="!isTaskEdit"
            >
              <option
                v-for="talent in talents.filter((t) => t.user)"
                :key="talent.talent_id"
                :value="talent.talent_id"
                :selected="isTaskEdit && talent.talent_id === newTask.assigned_to"
              >
                {{ talent?.user?.first_name }}
                {{ talent?.user?.last_name }}
                ({{ talent?.user?.email }})
              </option>
            </select>
            <p
              v-else-if="!loading"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
            >
              {{ talents[0].user.first_name }}
              {{ talents[0].user.last_name }} ({{ talents[0].user.email }})
            </p>
          </div>

          <div v-if="isTeamsSelected">
            <label class="block text-[13px] font-medium text-gray-700"
              >Teams</label
            >
            <select
              v-if="(!loading && isAdmin) || isManager"
              v-model="newTask.team_id"
              placeholder="Select team"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              :required="!isTaskEdit"
            >
              <option
                v-for="team in teams"
                :key="team.team_id"
                :value="team.team_id"
                :selected="isTaskEdit && team.team_id === newTask.team_id"
              >
                {{ team.team_name }}
                ({{ team.member_count }})
              </option>
            </select>
            <p
              v-else-if="!loading"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
            >
              {{ teamName  || "No team available in this project"}}
            </p>
          </div>
        </div>
        <div class="flex justify-end mb-4 text-[14px]">
          <button
            type="button"
            class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="flex items-center gap-2 py-2 px-4 bg-primaryDarkBg w-[146px] h-[42px] text-white rounded"
          >
            <img src="@/assets/dashboard/add.svg" alt="User icon" class="h-4" />
            {{isTaskEdit ? 'Edit Task' : 'Create Task'}}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
export default {
  name: "CreateTaskModal",
  components: {
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    talents: {
      type: Array,
      required: true,
    },
    members: {
      typer: Array,
      required: true,
    },
    teams: {
      type: Array,
      required: true,
    },
    talentName: {
      type: String,
      default: "",
    },
    talentEmail: {
      type: String,
      default: "",
    },
    teamName: {
      type: String,
      default: "",
    },
    talentId: {
      type: Number,
      default: 0,
    },
    TaskAssignedTo: {
      type: Number,
      default: Number,
    },
    prefilledTask: {
      type: Object,
      default: null,
    },
    isTaskEdit: {
      type: Boolean,
      default: false,
    },
  },
  // props: {
  //   isVisible: {
  //     type: Boolean,
  //     required: true
  //   },

  // },
  data() {
    return {
      loading: false,
      isTeamsSelected: this.isTaskEdit && this.prefilledTask
        ? this.prefilledTask.team !== null
        : false,
      newTask: {
        assigned_to: this.prefilledTask ? this.prefilledTask.assigned_to : null,
        team_id: this.prefilledTask ? this.prefilledTask.team_id : null,
        title: this.prefilledTask ? this.prefilledTask.title : "",
        description: this.prefilledTask ? this.prefilledTask.description : "",
        priority: this.prefilledTask ? this.prefilledTask.priority : "Medium",
        due_date: this.prefilledTask ? this.prefilledTask.due_date : "",
        // status: 'Not Started'
      },
      project: {},
      // talents: [],
    };
  },
  watch: {
    showModal(newValue) {
      if (newValue) {
        if (this.isTaskEdit && this.prefilledTask) {
          this.newTask = { ...this.prefilledTask }; // Prefill modal with task details
          this.isTeamsSelected = this.prefilledTask.team !== null;
        } else {
          this.resetForm();
          this.isTeamsSelected = false; 
        }
      }
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
  },
  methods: {
    emitOpenCreateTaskModal() {},
    async fetchProject() {
      this.loading = true;
      const projectId = this.$route.params.projectId;
      try {
        const response = await apiClient.get(`/web/projects/${projectId}`);
        this.project = response.data.data;
      } catch (error) {
        this.$toast.error('Failed to fetch project details.');
        console.error("Error fetching project data:", error);
      } finally {
        this.loading = false;
      }
    },

    async submitTaskModal() {
      if (this.isTaskEdit) {
        await this.editTask();
      } else {
        await this.createTask();
      }
    },

    async createTask() {
      console.log("Creating task with data:", this.newTask);
      // Validate that all required fields are filled
      if (
        !this.newTask.title ||
        !this.newTask.description ||
        !this.newTask.priority ||
        !this.newTask.due_date
      ) {
        this.$toast.error('Please fill in all required fields');
        return;
      }

      if(this.isAdmin || this.isManager){
        if(!(this.newTask.assigned_to || this.newTask.team_id)){
          this.$toast.error('Please assign the task to a team member or a team.');
          return;
        }
      } else {
        this.newTask.assigned_to = this.talents[0].talent_id;
      }

      const projectId = this.projectId || this.$route.params.projectId;

      // For talents, use their own ID if not explicitly assigned to someone else
      // let talentId = this.newTask.assigned_to;
      // if (this.isTalent && !talentId) {
      //   talentId = this.talentId;
      // }

      try {
        // Attempt to add the talent as a project member
        // const addMemberPayload = {
        //   talent_id: talentId,
        //   project_id: projectId,
        //   position: "Member",
        // };

        // if (talentId) {
        //   try {
        //     await apiClient.post(
        //       `/web/projects/${projectId}/project_members/`,
        //       addMemberPayload,
        //       {
        //         params: {
        //           talent_id: talentId,
        //         },
        //       }
        //     );
        //     console.log(`Talent ${talentId} added as a project member.`);
        //   } catch (error) {
        //     if (
        //       error.response?.data?.message === "Project member already exists"
        //     ) {
        //       console.warn("Talent is already a member of the project.");
        //     } else {
        //       console.error("Error adding member:", error);
        //       console.warn("Continuing with task creation despite member addition failure");
        //     }
        //   }
        // }

        // Create the new task with properly formatted date
        let formattedDate = this.newTask.due_date;
        if (formattedDate && !formattedDate.includes("T")) {
          formattedDate = `${formattedDate}T00:00:00`;
        }

        const newTask = {
          assigned_to: this.newTask.assigned_to,
          title: this.newTask.title,
          description: this.newTask.description,
          priority: this.newTask.priority,
          due_date: formattedDate,
          team_id: this.newTask.team_id || null,
        };

        const response = await apiClient.post(
          `/web/projects/${projectId}/tasks/`,
          newTask
        );

        // Show success message
        this.$toast.success('Task created successfully!');

        // Get latest tasks immediately after creating a new one
        const tasksResponse = await apiClient.get(
          `/web/projects/${projectId}/tasks`
        );
        const updatedTasks = tasksResponse.data.data;

        // Important: Pass the updated tasks list to parent
        this.$emit("task-created", {
          message: "Task created successfully!",
          task: response.data.data,
        });

        // Send the full updated task list to the parent
        this.$emit("refresh-tasks", updatedTasks);

        // Reset form fields
        this.resetForm();

        // Give parent time to update before closing modal
        setTimeout(() => {
          this.$emit("close");
        }, 500);
      } catch (error) {
        console.error("Error creating task:", error);

        if (error.response?.status === 422) {
          const details = error.response?.data?.detail;
          if (details && details.length > 0) {
            const fieldErrors = details.map((detail) => {
              const field = detail.loc[detail.loc.length - 1];
              return `${
                field.charAt(0).toUpperCase() + field.slice(1).replace("_", " ")
              }: ${detail.msg}`;
            });
            this.$toast.error(fieldErrors.join(", "));
          } else {
            this.$toast.error("Validation error. Please check your inputs.");
          }
        } else {
          this.$toast.error(error.response?.data?.message || "An unexpected error occurred.");
        }
      }
    },

    async editTask() {
      console.log("Editing task with data:", this.newTask);
      const projectId = this.projectId || this.$route.params.projectId;
      const taskId = this.prefilledTask.task_id;

      try {
        let formattedDate = this.newTask.due_date;
        if (formattedDate && !formattedDate.includes("T")) {
          formattedDate = `${formattedDate}T00:00:00`;
        }

        const updatedTask = {
          assigned_to: this.newTask.assigned_to,
          title: this.newTask.title,
          description: this.newTask.description,
          priority: this.newTask.priority,
          due_date: formattedDate,
          team_id: this.newTask.team_id || null,
        };

        const response = await apiClient.put(
          `/web/tasks/${taskId}?project_id=${projectId}`,
          updatedTask
        );

        // Show success message
        this.$toast.success('Task updated successfully!');

        // Get latest tasks immediately after updating
        const tasksResponse = await apiClient.get(
          `/web/projects/${projectId}/tasks`
        );
        const updatedTasks = tasksResponse.data.data;

        // Pass the updated tasks list to parent
        this.$emit("task-updated", {
          message: "Task updated successfully!",
          task: response.data.data,
        });

        // Send the full updated task list to the parent
        this.$emit("refresh-tasks", updatedTasks);

        // Give parent time to update before closing modal
        setTimeout(() => {
          this.$emit("close");
        }, 500);
      } catch (error) {
        console.error("Error updating task:", error);
        this.$toast.error(error.response?.data?.message || "An unexpected error occurred.");
      }
    },

    async fetchTasks(projectId) {
      try {
        const response = await apiClient.get(
          `/web/projects/${projectId}/tasks`
        );
        this.tasks = response.data.data;
      } catch (error) {
        console.error("Error fetching tasks data:", error);
      }
    },

    closeModal() {
      this.$emit("close"); // Emit close event to parent
      this.clearErrorMessage(); // Clear error message on modal close
    },
    clearErrorMessage() {
      // no-op
    },

    emitTaskData() {
      // Clear any previous error before submitting
      this.showError = false;
      this.errorMessage = "";
      this.$emit("save-task", { ...this.task });
    },
    // Method to be called when there's an error from the parent
    handleTaskError(message) {
      this.$toast.error(message);
    },

    resetForm() {
      this.newTask = {
        assigned_to: this.isTalent ? this.talentId : "",
        title: "",
        description: "",
        priority: "medium",
        due_date: "",
        task_status: "",
      };
    },
  },
  created() {
    const projectId = this.$route.params.projectId;

    this.fetchTasks(projectId);
  },
};
</script>

<style scoped>
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: 50;
}

.smoke-light {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  z-index: 60;
}
</style>